import styled, { css } from "styled-components";
import { mobile, tablet, Button, desktop, portalColors } from "src/components";
import Dropzone from "react-dropzone";
import ArrowDownSignToNavigate from "src/img/arrow-down-sign-to-navigate.svg";

// Cancel Button
export const CancelButton = styled(Button)`
    width: 140px;
    color: ${portalColors.text};
    border: 1px solid ${portalColors.borderStrong};
    height: ${p => p.height || "42px"};
    border-radius: ${p => p.borderRadius || "8px"} !important;
    background: ${portalColors.surface};
    opacity: 1;
    box-shadow: none;
`;
// Save Button
export const SaveButton = styled(Button)`
    width: ${p => p.width || "140px"};
    background: ${p => p.backgroundColor || "#ffffff"};
    color: ${p => p.color || "#FFFFFF"};
    border: ${p => p.border || `1px solid ${portalColors.text}`};
    height: ${p => p.height || "42px"};
    border-radius: ${p => p.borderRadius || "8px"} !important;
    background: ${portalColors.text};
    box-shadow: none;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`;
// Field and preview container
export const FormContainer = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    max-width: ${p => p.maxWidth || "799px"};
    height: ${p => p.height || "100vh"};
    background: ${portalColors.surface};
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);
    overflow: ${p => p.overflow || "auto"};
    overflow-x: hidden; 
    min-height: 5.625rem;
    border-radius: 16px;
    border: 1px solid ${portalColors.border};
    box-sizing: border-box;
    margin-bottom: 2.5rem;
    align-items: center;
    
    ${tablet`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};

    ${mobile`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};

    ${desktop`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};
`;
// Main Container use in Main Add Quotes Page
export const ContentHeaderContainer = styled.div`
    display: flex;
    flex-direction: ${p => p.flexDirection || "row"};
    justify-content: ${p => p.justifyContent || "flex-start"};
    align-items: ${p => p.alignItems || "center"};
    gap: ${p => p.gap || "1rem"};
    width: ${p => p.width || "100%"};
    max-width: ${p => p.maxWidth};
    margin-top: ${p => p.marginTop || "1rem"};
    margin-bottom: ${p => p.marginBottom};
    padding: 0.9rem 1rem;
    box-sizing: border-box;
    background: ${portalColors.surface};
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);

    @media (max-width: 1440px) {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }

    @media (max-width: 900px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

export const LeftContainer = styled.div`
    width: 100%;
    max-width: 799px;
    position: relative;
    overflow: auto;
`;
export const RightContainer = styled.div`
    width: 100%;
    max-width: 566px;
    overflow: auto;
`;

// Browse field button
export const BrowseFileButton = styled.div`
    width: 140px;
    height: 38px;
    background-color: ${portalColors.text};
    box-shadow: none;
    border-radius: 8px;
    color: #fff;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 0.875rem;
    font-family: "Manrope", "Helvetica", sans-serif;
`;
//  Upload Quotes and article image field
export const ImageContainer = styled(Dropzone)`
    height: ${p => p.height || "480px"};
    width: ${p => p.width || "222px"};
    position: relative;
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    background: ${portalColors.surfaceSoft};
    margin: ${p => p.margin || "0"};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
//  Image below Description field
export const InputDescription = styled.p`
    font-family: Manrope, Hevetica, sans-serif;
    font-weight: ${p => p.fontWeight || "normal"};
    font-size: ${p => p.size || "0.875rem"};
    color: ${p => p.color || portalColors.mutedText};
    margin: ${p => p.margin || "4px 0 8px"};
    text-align: ${p => p.align || "left"};
    margin-bottom: 1em;
`;

//Text label
export const TextLabel = styled.div`
    display: flex;
    margin-bottom: ${p => p.marginBottom || "10px"};
    text-align: left;
    font: ${p => p.font || "normal normal 800 25px/33px Manrope"};
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: ${p => p.fontWeight || "800"};
    font-size: ${p => p.fontSize || "16px"};
    color: ${p => p.color || portalColors.text} !important;
    opacity: 1;
`;

//  Display Selected Iamge Field
export const ImagePreview = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 14px;
`;
//  Text Area Field
export const TextArea = styled.textarea`
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.text};
    font-size: ${p => p.fontSize || "1rem"};
    width: 100%;
    box-sizing: border-box;
    box-shadow: none;
    height: ${p => p.height || "180px"};
    border: 1px solid ${portalColors.borderStrong};
    padding: 10px 20px;
    border-radius: 8px;
    text-align: left;
    font-weight: 400;
    caret-color: #000;
    resize: none;

    ::placeholder {
        color: ${portalColors.textSoft};
        font-weight: 400;
        text-align: left;
        font-size: ${p => p.placeholderSize || "0.875rem"};
    }
    
    &:focus {
        outline: none;
        border: 1px solid ${portalColors.text};
        box-shadow: 0 0 0 4px ${portalColors.blueSoft};
    };
    
    ${p => p.isHighlighted && css`
        border: 1px solid red !important;
    `};
`;

export const ErrorMessage = styled.div`
    font-size: 11.5px;
    color: #ff7171;
    font-weight: 500;
    line-height: 12.5px;
    margin: 4px 0 0 4px;
`;

export const SpinnerContainer = styled.div`
    width: 2.188rem;
`;

export const CardHolder = styled.div`

    ${mobile`
        display: flex;
        flex-direction: column;
        gap: 20px;
    `};

    ${tablet`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;
    `};

    @media (min-width: 768px) and (max-width: 1024px){
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    @media (min-width: 1025px) and (max-width: 1440px){
        display: flex;
        flex-direction: row;
        gap: 20px;
    }
    
    @media (min-width: 1441px){
        display: flex;
        flex-direction: row;
        gap: 20px;
        flex-wrap: nowrap;
    }
`;

export const InputSelector = styled.select`
    font-size: ${p => p.size || "0.8rem"};
    font-weight: ${p => p.fontWeight || 500};
    height: 2.4375rem !important;
    width: ${p => p.width || "12.5rem !important"};
    border: 1px solid ${portalColors.border};
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 7px;
    padding-left: 1em;
    background-color: ${portalColors.surfaceSoft};
    background-image: url(${ArrowDownSignToNavigate});
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: 50%;
    appearance: none;
    margin-right: 2em;
    text-align: left;
    font-family: 'Manrope', 'Arial', sans-serif;
    letter-spacing: 0px;
    color: ${portalColors.text};
    ${mobile`
        max-width: 200px;
        margin: 0;
    `}

    ${tablet`
        max-width: 400px;
        margin: 0;
    `}

    ${desktop`
        max-width: 545px;
        margin: 0 ;
    `}
`;

export const RemoveMediaButton = styled.button` 
    display: flex;
    position: absolute;
    z-index: 99999;
    right: -8px;
    top: 32px;
    width: 24px;
    height: 24px;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #000000;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${portalColors.surface};
    pointer-events: auto;
`;
